import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AddInstructorModal from "../../../components/AddInstructorModal/AddInstructorModal";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import dummyPlaceholder from "../../../assets/images/dummyPlaceholder.jpg";
import { useSelector } from "react-redux";
import axios from "axios";
import { Image } from "react-bootstrap";
import { BASE_URL } from "../../../redux/ApiEndPoints";
import AdminNotification from "../../../components/Notification/AdminNotification";
import toast from "react-hot-toast";

const Instructors = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [instructorsData, setInstructorsData] = useState([]);
  const [filteredInstructors, setFilteredInstructors] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const auth = useSelector((state) => state.auth);

  const fetchInstructors = async () => {
    setLoading(true);
    try {
      const token = auth?.token;
      if (!token)
        throw new Error("No authentication token found. Please log in.");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}admin/instructors`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const instructors = response.data.data.details || [];
      setInstructorsData(instructors);
      setFilteredInstructors(instructors);
    } catch (error) {
      console.error("Error fetching instructors:", error);
      setError(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch instructors."
      );
      toast.error(error.response?.data?.message || error.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstructors();
  }, [auth?.token]);

  // Handle search input change
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = instructorsData.filter((instructor) => {
      const fullName = instructor.full_name || "";
      const email = instructor.email || "";
      return (
        fullName.toLowerCase().includes(query) ||
        email.toLowerCase().includes(query)
      );
    });
    setFilteredInstructors(filtered);
  };

  return (
    <>
      {loading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <div className="container-fluid">
        <div className="topbar mb-20 mb-lg-36">
          <div className="d-flex align-items-center justify-content-between">
            <h3
              className="ad-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <span className="icon-arrow-left"></span>Instructors
            </h3>
            <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
              <DashboardTopSearch
                onSearch={handleSearch}
                searchQuery={searchQuery}
              />
              <AdminNotification />
            </div>
          </div>
        </div>
        <div className="card-default-style px-10 px-sm-20 px-md-30 px-lg-47 py-10 py-sm-20 py-md-30 py-lg-42">
          <div className="d-flex justify-content-between align-items-center mb-10 mb-sm-20 mb-md-30 mb-lg-40 flex-wrap">
            <h3 className="ad-heading-05 fw-bold black-900">Instructors</h3>
            <div className="d-flex align-items-center flex-wrap justify-content-end flex-grow-1">
              <div className="position-relative search-wrapper-2 me-10 mb-10 mb-sm-0">
                <input
                  type="text"
                  className="form-control pe-30 ah-text-base"
                  placeholder="Search instructor"
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <span className="icon-search position-absolute"></span>
              </div>
              <button
                className="btn btn-primary mb-10 mb-sm-0 no-shadow d-flex align-items-center gap-2 w-auto py-13"
                onClick={() => setModalShow(true)}
              >
                <span className="icon-Add "></span>Add Instructor
              </button>
            </div>
          </div>
          {/* {loading && <div className="alert alert-info">Loading...</div>} */}
          {/* {error && <div className="alert alert-danger">{error}</div>} */}
          {!loading && filteredInstructors.length === 0 && !error && (
            <div className="alert alert-info">No instructors found.</div>
          )}

          <div className="row instructor-item-list flex-wrap">
            {filteredInstructors.map((instructor) => {
              // const imageUrl =
              //   "https://egwb.logoinnovators.com/public/profile_pictures/profile_picture-1750172361347-239989386.png";
              return (
                <div className="col mb-25" key={instructor.id}>
                  <article className="instructors-item d-flex h-100">
                    <Link
                      to={`/instructor-details?id=${instructor.id}`}
                      className="instructors-item-wrapper w-100"
                    >
                      <div className="img-holder mb-9">
                        <Image
                          src={
                            instructor?.profile_picture?.startsWith("/")
                              ? process.env.REACT_APP_GALLERY_URL +
                                "/" +
                                instructor?.profile_picture?.substring(1)
                              : process.env.REACT_APP_GALLERY_URL +
                                instructor?.profile_picture
                          }
                          alt={instructor.full_name || "Instructor"}
                          className="img-fluid"
                          onError={(e) => {
                            console.warn("Image failed to load:", e.target.src);
                            e.target.onerror = null;
                            e.target.src = dummyPlaceholder;
                          }}
                        />
                      </div>
                      <h4 className="ah-text-base fw-semibold mb-6 black-900 text-capitalize">
                        {instructor.full_name || instructor.email}
                      </h4>
                      <p className="ah-text-xs black-400 mb-6">
                        {instructor.role?.name || "Instructor"}
                      </p>
                      {instructor.status === "complete" ? (
                        <span
                          className="btn btn-soft-green text-green py-9 ah-text-sm w-100 no-shadow bg-transparent mt-auto fw-normal"
                          style={{ lineHeight: "25px", borderColor: "#82BD00" }}
                        >
                          Profile Completed
                        </span>
                      ) : (
                        <span
                          className={`btn btn-outline-primary no-hover py-9 ah-text-sm w-100 no-shadow mt-auto fw-normal`}
                        >
                          Profile Incomplete
                        </span>
                      )}
                    </Link>
                  </article>
                </div>
              );
            })}
          </div>
        </div>
        <AddInstructorModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          onSuccess={fetchInstructors}
        />
      </div>
    </>
  );
};

export default Instructors;
